import { useAtomValue } from "jotai";

import { UpdateEmailOrPhoneProfileStepStateAtom } from "../atoms/stores";
import { InitialStep } from "./components/InitialStep/InitialStep";
import { VerifyCodeStep } from "./components/VerifyCodeStep/VerifyCodeStep";

export const UpdateEmailOrPhoneProfileBody = ({
  defaultCountryCodeId,
  updateEmailOrPhone,
}: {
  defaultCountryCodeId: string;
  updateEmailOrPhone: "phone" | "email" | null;
}) => {
  const stepState = useAtomValue(UpdateEmailOrPhoneProfileStepStateAtom);
  const currentStep = stepState.step;

  switch (currentStep) {
    case "Initial":
      return (
        <InitialStep
          defaultCountryCodeId={defaultCountryCodeId}
          updateEmailOrPhone={updateEmailOrPhone}
        />
      );
    case "VerifyCode":
      return <VerifyCodeStep updateEmailOrPhone={updateEmailOrPhone} />;
    default:
      return null;
  }
};
